function modulo11Check(number) {
    /**
   * A 9 digit ADAC membership number consists of a 8 digit person
   * number plus a check digit (last digit).
   * 
   * Validity is checked with a Modulo11 variant
   * - Multiplication of the digits of the person number (digits 1 to 8) with a weighting of 3, 2, 7, 6, 5, 4, 3, 2
   * - Addition of the results of the multiplications
   * - Dividing the result of the addition by 11
   * - Subtracting the modulo from 11
   *   - result of subtraction 11 -> check digit 0
   *   - result of subtraction 10 -> check digit 0
   *   - result of subtraction 1 to 0 -> check digit = result
   * 
   * If the last digit of the given membership number matches the calculate
   * check digit, the membership number is valid
   */
    const membershipNumber = `000000000${number}`.substring(number.length);
    let checkDigit;
    let prodSum = 0;
    let multi = 2;
    for (let i = 7; i >= 0; i--) {
        prodSum += Number(membershipNumber.substring(i, i + 1)) * multi;
        if (multi === 7) {
            multi = 2;
        } else {
            multi++;
        }
    }

    const mod = 11 - (prodSum % 11);

    if (mod === 10 || mod === 11) {
        checkDigit = 0;
    } else {
        checkDigit = mod;
    }
    return checkDigit === Number(membershipNumber.substring(8, 9));
}

export default () => {
    return {
        isValidMembershipNo: (membershipNo) => {
            const ADAC_MEMBERSHIP_NO_REGEXP_ADAC_MEMBER = /^(?!0+$)[0-9]{0,9}$/;
            const number = String(membershipNo);
            return ADAC_MEMBERSHIP_NO_REGEXP_ADAC_MEMBER.test(number) 
                && modulo11Check(number);
        }
    };
};
